import React, { useRef, useState } from "react"
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Row,
    Col,
    Button,
    Media
} from "reactstrap";
import { withTranslation } from "react-i18next";
import QRCode from 'qrcode-react';
import * as Helper from "../../../utils/Helper";

import UIDs from "../../../UIDs";
const uid = UIDs.screens.admin.promotion.promotiondetails;

const PromotionDetails = (props) => {
    let { banners, promotionInfo, showDescr} = props;
    if(!promotionInfo){
        promotionInfo = [];
    }
    const { id, name, description, startDate, endDate,
            weChatBannerDescription, copyWriting, teacherRefundDesc, agentRefundDesc, referralGuide,
            spreaderRewardJson, participantRewardJson } = promotionInfo;

    const [state_languageImg, setstate_languageImg] = useState("");
    const [state_language, setstate_language] = useState("zh");

    let bannersImg = [];
    let defLanguage = "";
    if(state_languageImg === "")
    {
        if(banners && banners.zh && banners.zh.length > 0){
            bannersImg = banners.zh;
            defLanguage = "zh";
        }else if(banners && banners.en && banners.en.length > 0){
            bannersImg = banners.en;
            defLanguage = "en"
        }else if(banners && banners.ko && banners.ko.length > 0){
            bannersImg = banners.ko;
            defLanguage = "ko"
        }else if(banners && banners.th && banners.th.length > 0){
            bannersImg = banners.th;
            defLanguage = "th"
        }
    }else{
        bannersImg = banners[state_languageImg];
        defLanguage = "";
    }

    let teacherShareUrl = window.location.protocol + "//" + window.location.host + "/plain/teachershare/"+id+"/" + props.userId;
    return (
        <>
            <CardBody style={{marginTop: props.email ? "100px" : "1px"}}>
                <div className="row">
                    <div className="col-lg-12">
                        <label className="form-control-label">{props.t("name")}</label>
                        <div style={divStyle}>{name}</div>
                    </div>
                </div>
                <div className="row" style={{marginTop:20}}>
                    <div className="col-lg-12">
                        <label className="form-control-label">{props.t("freeVIPTime")}</label>
                        <div style={divStyle}>{participantRewardJson ? parseInt(participantRewardJson.rewardData.freeDays/30) : ""}</div>
                    </div>
                </div>
                <div className="row" style={{marginTop:20}}>
                    {/*<div className="col-lg-6">
                        <label className="form-control-label">{props.t("startDate")}</label>
                        <div style={divStyle}>{new Date(startDate).toLocaleDateString()}</div>
                    </div>*/}
                    <div className="col-lg-12">
                        <label className="form-control-label">{props.t("endDate")}</label>
                        <div style={divStyle}>{new Date(endDate).toLocaleDateString()}</div>
                    </div>
                </div>
                {bannersImg.length > 0 &&<div className="row" style={{marginTop:20}}>
                    <div className="col-lg-12">
                        <label className="form-control-label">{props.t("banners")}</label>
                        <div style={{marginTop: 10, marginBottom: 10}}>
                            {banners && banners.zh && banners.zh.length > 0 ? <Button color={state_languageImg === "zh" || defLanguage === "zh" ? "primary" : ""} onClick={() => { setstate_languageImg("zh"); }} size="sm"> {props.t("btnzh")}</Button>:null}
                            {banners && banners.en && banners.en.length > 0 ? <Button color={state_languageImg === "en" || defLanguage === "en" ? "primary" : ""} onClick={() => { setstate_languageImg("en"); }} size="sm"> {props.t("btnen")}</Button>:null}
                            {banners && banners.ko && banners.ko.length > 0 ? <Button color={state_languageImg === "ko" || defLanguage === "ko" ? "primary" : ""} onClick={() => { setstate_languageImg("ko"); }} size="sm"> {props.t("btnko")}</Button>:null}
                            {banners && banners.th && banners.th.length > 0 ? <Button color={state_languageImg === "th" || defLanguage === "th" ? "primary" : ""} onClick={() => { setstate_languageImg("th"); }} size="sm"> {props.t("btnth")}</Button>:null}
                        </div>
                        <div style={{clear:"both"}}>
                            {
                                bannersImg.map((path, index)=>{
                                    return(
                                        <div style={{float:"left", marginRight:10}}>
                                            <img src={Helper.convertToFileServerPath(path)} alt="..." style={imgStyle} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>}
            </CardBody>
            <div style={{borderBottom:"1px solid #cad1d7", width:"100%", paddingBottom:"20px"}}></div>
            <CardBody>
                {weChatBannerDescription && <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("weChatBannerDescription")}</label>
                            <div style={divStyle}>{weChatBannerDescription}</div>
                        </div>
                    </div>
                </div>}
                {copyWriting && copyWriting.length > 0 && <><div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("copyWriting")}</label>
                            <div style={{marginTop: 10, marginBottom: 10}}>
                                <Button color={state_language === "zh" ? "primary" : ""} onClick={() => { setstate_language("zh"); }} size="sm"> {props.t("btnzh")}</Button>
                                <Button color={state_language === "en" ? "primary" : ""} onClick={() => { setstate_language("en"); }} size="sm"> {props.t("btnen")}</Button>
                                <Button color={state_language === "ko" ? "primary" : ""} onClick={() => { setstate_language("ko"); }} size="sm"> {props.t("btnko")}</Button>
                                <Button color={state_language === "th" ? "primary" : ""} onClick={() => { setstate_language("th"); }} size="sm"> {props.t("btnth")}</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: -10}}>
                    <div className="col-lg-12">
                        <div className="form-group">
                            {
                                copyWriting && copyWriting.map((item, index)=>{

                                    return(
                                        <div style={{marginBottom:20}}>
                                            <label className="form-control-label">{props.t("copyWritingNum", {num: index+1})}</label>
                                            <div style={divStyle}>{Helper.localizeStringByLanguage(item, state_language)}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div></>}
                {props.userId?<div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("qrcode")}</label>
                            <div><QRCode size={150} value={teacherShareUrl}  /></div>
                        </div>
                    </div>
                </div>: null}
                {referralGuide &&<div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("referralGuide")}</label>
                            <div style={divStyleNobg}>
                                <span dangerouslySetInnerHTML={{__html: referralGuide}}></span>
                            </div>
                        </div>
                    </div>
                </div>}
            </CardBody>
            <div style={{borderBottom:"1px solid #cad1d7", width:"100%", paddingBottom:"20px"}}></div>
            <CardBody>
                {(showDescr === "all" || showDescr === "teacher") && teacherRefundDesc && teacherRefundDesc.length > 0 ? <> <div className="row" style={{marginBottom: -10}}>
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("teacherRefundDesc")}</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            {
                                teacherRefundDesc && teacherRefundDesc.map((item, index)=>{
                                    return (
                                        <div style={{marginBottom:20}}>
                                            <label className="form-control-label">{props.t("refundNum", {num: index+1})}</label>
                                            <div style={divStyle}>{Helper.localizeStringByLanguage(item, "zh")}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div></>:null}
                {(showDescr === "all" || showDescr === "agent") && agentRefundDesc && agentRefundDesc.length > 0 ? <><div className="row" style={{marginBottom: -10}}>
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label className="form-control-label">{props.t("agentRefundDesc")}</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            {
                                agentRefundDesc && agentRefundDesc.map((item, index)=>{
                                    return (
                                        <div style={{marginBottom:20}}>
                                            <label className="form-control-label">{props.t("refundNum", {num: index+1})}</label>
                                            <div style={divStyle}>{Helper.localizeStringByLanguage(item, "zh")}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div></>: null}
            </CardBody>
        </>
    )
}

const divStyle = {
    border:"1px solid #cad1d7",
    padding:"10px 15px",
    borderRadius:5,
    backgroundColor:"#e9ecef",
    opacity: 1,
    color:"#8898aa"
}

const divStyleNobg = {
    border:"1px solid #cad1d7",
    padding:"10px 15px",
    borderRadius:5,
    opacity: 1,
    color:"#8898aa"
}

const imgStyle = {
    width:"375px",
    height:"667px",
    marginRight:"10px"
}
export default withTranslation(uid)(PromotionDetails);